import { render, staticRenderFns } from "./onPlsc.vue?vue&type=template&id=5f677544"
import script from "./onPlsc.vue?vue&type=script&lang=js"
export * from "./onPlsc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports